import useStateStore from 'services/store';
import FloatConfigContainer from '../FloatConfigContainer/FloatConfigContainer';
import FloatConfigHeader from '../FloatConfigContainer/FloatConfigHeader/FloatConfigHeader';
import { useEffect, useState } from 'react';
import { TypeColors } from 'services/types';

const Stitch = () => {
  const [stitches, setStitches] = useState<TypeColors[]>();
  useEffect(() => {
    fetch('data/stitches.json')
      .then((response) => response.json())
      .then((data) => {
        setStitches(data);
      })
      .catch((error) => {
        console.error('Error fetching stitches:', error);
      });
  }, []);

  const { setStitch, activeFabric, activeProductData, setStitchApply } =
    useStateStore();

  return (
    <FloatConfigContainer>
      <FloatConfigHeader />
      <div className="body">
        <div className="add-fee">+ $10</div>
        <span className="checkox-for-all-stitch">
          <label className="label" htmlFor="last-button">
            Only last button
          </label>
          <input
            onChange={() => setStitchApply()}
            checked={
              activeProductData?.[activeFabric]?.stitch.theLastOne
                ? true
                : false
            }
            className="input"
            id="last-button"
            type="checkbox"
          />
        </span>
        <div className="colors-container">
          {stitches &&
            stitches.length > 0 &&
            stitches.map((clr) => {
              return (
                <div
                  onClick={() => setStitch(clr.id, clr.value)}
                  key={clr.id}
                  className={`color-option ${
                    activeProductData?.[activeFabric]?.stitch.value === clr.id
                      ? 'active'
                      : ''
                  }`}
                >
                  <div className="color-container">
                    <div className="icon-container">
                      <img
                        className="check"
                        src="images/configurator/check.svg"
                        alt=""
                      />
                    </div>
                    <img className="main-img" src={clr.img} alt="" />
                  </div>
                  <div className="name">{clr.text}</div>
                </div>
              );
            })}
        </div>
      </div>
    </FloatConfigContainer>
  );
};

export default Stitch;
